export default {
  guides: {
    title: 'Гиды по призванию',
    subtitle: 'Встречи с интересными людьми, куда бы вы ни поехали',
  },
  articles: {
    title: 'Журнал о путешествиях',
    subtitle: 'Готовые маршруты, полезные инструкции, лайфхаки и подборки лучших мест',
  },
  seo: {
    title: 'Трипстер — Необычные экскурсии и туры по всему миру',
    // Цифры (951 город, 302033 отзыва) — маркетинговые метрики, которые обновляются вручную.
    // Живых счётчиков в SEO-описании нет, поэтому значения нужно периодически актуализировать.
    description:
      'Необычные экскурсии в 951 городе мира. Гиды — историки, журналисты, архитекторы и другие люди, которые умеют увлечь своими знаниями. Все экскурсии на русском, индивидуальные — для вас и вашей компании. На сайте больше 302033 отзывов!',
    alternateName: 'Трипстер',
  },
} as const;
